import { Link } from 'react-router-dom'

export function Terms() {
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="max-w-3xl mx-auto px-6 py-12">
        <div className="mb-8 flex items-center justify-between">
          <Link
            to="/"
            className="text-sm text-gray-400 hover:text-[#D4AF37] transition-colors"
          >
            &larr; Back to Home
          </Link>
          <span className="text-xs uppercase tracking-[0.2em] text-gray-500">
            Legal
          </span>
        </div>

        <h1 className="text-3xl md:text-4xl font-bold mb-4 bg-gradient-to-r from-[#D4AF37] to-[#FFD700] bg-clip-text text-transparent">
          Terms of Service
        </h1>
        <p className="text-gray-400 mb-8">
          These Terms of Service (&quot;Terms&quot;) govern your use of the Binyuma TV
          website, application, and related services (the &quot;Service&quot;). By
          creating an account or using the Service, you agree to be bound by these
          Terms.
        </p>

        <div className="space-y-6 text-sm md:text-base leading-relaxed text-gray-300">
          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              1. Eligibility & Age Requirements
            </h2>
            <p>
              You must be at least 13 years old or the minimum legal age of digital
              consent in your country to create an account and use Binyuma TV. Where
              required by law, children under the age of consent may only use the
              Service under the supervision of a parent or legal guardian who accepts
              these Terms on their behalf.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              2. Your Account
            </h2>
            <p>
              You are responsible for maintaining the confidentiality of your login
              credentials and for all activity that occurs under your account. You
              agree to provide accurate information and to promptly update it if it
              changes. We may suspend or terminate accounts that violate these Terms
              or applicable laws.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              3. Content & Usage Rules
            </h2>
            <p>
              Binyuma TV hosts curated and creator-submitted content, including films
              and series that may not be suitable for all audiences. You agree not to
              attempt to bypass any age-based, regional, or subscription restrictions
              we apply to protect users and comply with platform policies.
            </p>
            <p className="mt-2">
              You also agree not to: copy or redistribute content without permission,
              interfere with or disrupt the Service, misuse reporting tools, harass or
              abuse other users or creators, or use the Service for any unlawful
              purpose.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              4. Subscriptions & Purchases
            </h2>
            <p>
              Some content or features may require a paid subscription or one-time
              purchase. Billing terms, renewal, and cancellation policies will be
              presented at the point of purchase and may be managed through your app
              store account or payment provider. Except where required by law, fees are
              non-refundable.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              5. Changes to the Service
            </h2>
            <p>
              We may update or modify the Service over time, including adding or
              removing features or content. We may also update these Terms as needed.
              When changes are material, we will provide reasonable notice within the
              app, on the website, or via email where appropriate. Continued use of the
              Service after changes take effect constitutes acceptance of the updated
              Terms.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              6. Termination
            </h2>
            <p>
              We may suspend or terminate your access to the Service if you materially
              breach these Terms, misuse the platform, or where required by law or by
              our distribution partners. You may stop using the Service at any time and
              may request deletion of your account where supported.
            </p>
          </section>

          <section>
            <h2 className="text-lg font-semibold text-white mb-2">
              7. Contact
            </h2>
            <p>
              If you have questions about these Terms or about Binyuma TV, please
              contact us using the support information provided in the app or on our
              website.
            </p>
          </section>
        </div>
      </div>
    </div>
  )
}
